import React, { PureComponent } from "react";
import "./Metric.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default class extends PureComponent {
  render() {
    return (
      <div className="metric">
        <span className={"metric-icon metric-icon-" + this.props.type}>
          <FontAwesomeIcon icon={this.props.icon} />
        </span>
        <span className="metric-value">{this.props.value}</span>
        <span className="metric-name">{this.props.name}</span>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Metric.js